import store from '../../store';
import env from '../../enviroment';
import backendApi from './backendApi';
import lilaiframeApi from "./lilaIframeApi";
import { login, logout } from './zdjApi';

const processBackendResult = (response) => new Promise((resolve, reject) => {
    console.log("processBackendResult:", response);
    console.log("response.status:", response.status);
    if (response && response.status === "ok") resolve(response.data)
    else reject(processError(response))
});

const processError = (response) => {
    console.log("processError:", response);
    response && console.log("Error:", response.status, response.code);
    if (!response) return (new Error("Empty response"))
    else if (response.status !== "error" && response.code !== "error") return (new Error("Unexpected response"))
    else if (!response.details && !response.messages) return (new Error("No error details in response"))
    else return (new Error(response.details || response.messages))
}

const processSignup = (req) => new Promise((resolve, reject) => {
    req
        .then((response) => {
            // console.log('processSignup: response=', response)
            if (response.status === "ok" && (response.data.p && response.data.u)) {
                const {u, p} = response.data;
                resolve({
                    status: "ok",
                    data: {u, p}
                })
            } else {
                // console.log('erroare:', response)
                resolve({
                    status: 'error',
                    message: (response && response.message) || '',
                })
            }
        })
        .catch(error => {
            // console.log('Process got error', error)
            // console.log("error.message", error && error.message)
            if (error && error.message === "Request failed with status code 403") {
                store.dispatch("user/logout"); // should be re-login?
                reject("auth-failed")
            }
            reject(processError(error))
        })
})

const process = (req) => new Promise((resolve, reject) => {
    req
        .then((response) => {
            console.log('Process got response', response)
            processBackendResult(response)
                .then(data =>
                    resolve(data)
                )
                .catch(error => {
                    reject(error)
                });
        })
        .catch(error => {
            console.log('Process got error', error)
            console.log("error.message", error && error.message)
            if (error && error.message === "Request failed with status code 403") {
                store.dispatch("user/logout"); // should be re-login?
                reject("auth-failed")
            }
            reject(processError(error))
        });
});

const getCredentials = () => process(backendApi.getCredentials())

const getIframeFirstUrl = () => getIframeUrl("ca/gate")
const getIframeUrl = (uri) => `${env.zdjUrl}${uri}`

const initLilaIframe = () => lilaiframeApi.init();

const lilaInited = () => lilaiframeApi.isInited();

const signIn = (credentials) => process(lilaiframeApi.signIn(credentials));
const signUp = (login) => processSignup(backendApi.signup(login))

const getCredentialsAndLogin = () => getCredentials()
    .then(credentials => {
        return login(credentials.l, credentials.p)
    })

const tryLoginToZDJ = (f) => (to, from, next) =>
    f(to, from, (to, from) => {
        store.dispatch("zdj/login")
            // getCredentialsAndLogin()
            .then(() => next())
            .catch(() => next())
    })

const getZDJUrl = () => env.zdjUrl;

export default {
    getCredentials,
    getCredentialsAndLogin,
    getIframeUrl,
    getIframeFirstUrl,
    getZDJUrl,
    initLilaIframe,
    lilaInited,
    signUp,
    signIn,
    tryLoginToZDJ,
    login,
    logout,
};
